import { Icons } from 'components';
import styled from 'styled-components';

export const ReportButton = styled.button(({ theme }) => {
  return `
    border: 0;
    outline: none;
    padding: 0;
    margin: 0;
    line-height: 1;
    background: none;
    color: ${theme.colors.color30};
    text-transform: uppercase;
    font-size: 12px;
    cursor: pointer;

    &:hover {
      color: ${theme.colors.color80};
    }
  `;
});

export const ReplyButton = styled.button(({ theme, disabled }) => {
  return `
    border: 0;
    outline: none;
    padding: 0;
    margin: 0;
    line-height: 1;
    background: none;
    color: ${disabled ? theme.colors.color50 : theme.colors.primary_400};
    text-transform: uppercase;
    font-size: 14px;
    font-weight: ${theme.fontWeights.bold};
    cursor: pointer;

    &:hover {
      color: ${disabled ? theme.colors.color50 : theme.colors.primary_200};
    }
  `;
});

export const ReactionIcon = styled(Icons)``;

export const ReactionButton = styled.button(({ theme, disabled }) => {
  return `
    display: flex;
    align-items: center;
    border: 0;
    outline: none;
    padding: 0;
    margin: 0;
    line-height: 1;
    background: none;
    color: ${theme.colors.color50};
    font-size: 12px;
    cursor: pointer;
    margin-left: ${theme.space[5]}px;

    &:first-child {
      margin-left: 0;
    }

    ${ReactionIcon} {
      width: 18px;
      color: ${disabled ? theme.colors.color50 : theme.colors.primary_400};
      margin-right: 5px;
    }

    &:hover {
      
      ${ReactionIcon} {
        color: ${disabled ? theme.colors.color50 : theme.colors.primary_200};
      }
    }
  `;
});
